export enum PAYLOAD_NAMES {
    Company = "company",
    Code = "code"
}
